// Types for user trigger-notification preferences and real-time events.

export interface EmailNotificationPrefs {
  enabled: boolean;
  frequency: string;
  types: string[];
  email_addresses: string[];
}

export interface SmsNotificationPrefs {
  enabled: boolean;
  phone_number: string;
  carrier: string;
}

export interface DashboardAlertPrefs {
  enabled: boolean;
  sound_enabled: boolean;
  popup_enabled: boolean;
  alert_types: string[];
}

export interface TriggerEventPrefs {
  indicator_activated: boolean;
  execution_fired: boolean;
  execution_failed: boolean;
}

export interface NotificationPreferences {
  email_notifications: EmailNotificationPrefs;
  sms_notifications: SmsNotificationPrefs;
  dashboard_alerts: DashboardAlertPrefs;
  trigger_events: TriggerEventPrefs;
}

export interface CarrierOption {
  value: string;
  label: string;
}

export interface NotificationPreferencesResponse extends NotificationPreferences {
  smtp_configured: boolean;
  carriers: CarrierOption[];
}

export interface TestNotificationResponse {
  email: boolean;
  sms: boolean;
  websocket: boolean;
  smtp_configured: boolean;
  message?: string | null;
  email_error?: string | null;
  email_recipients?: string[];
}

export interface EmailDiagnosticStep {
  step: string;
  ok: boolean;
  detail: string;
}

export interface EmailDiagnosticsResponse {
  ok: boolean;
  error?: string | null;
  smtp_configured: boolean;
  sent_test_message_to?: string | null;
  config: Record<string, unknown>;
  steps: EmailDiagnosticStep[];
}

export interface InboundDiagnosticsResponse {
  ok: boolean;
  error?: string | null;
  config: Record<string, unknown>;
  steps: EmailDiagnosticStep[];
}

export type TriggerNotificationEvent =
  | 'indicator_activated'
  | 'indicator_deactivated'
  | 'execution_fired'
  | 'execution_failed'
  | 'test';

export interface TriggerNotificationMessage {
  type: 'trigger_notification' | 'connection_established' | 'pong' | 'error';
  event?: TriggerNotificationEvent;
  severity?: 'success' | 'error' | 'info';
  alert_id?: number | null;
  alert_name?: string;
  ticker?: string;
  order_type?: string;
  source?: string;
  status?: string;
  title?: string;
  message?: string;
  timestamp?: string;
}

export function defaultNotificationPreferences(): NotificationPreferences {
  return {
    email_notifications: {
      enabled: false,
      frequency: 'immediate',
      types: ['trading_alerts'],
      email_addresses: [],
    },
    sms_notifications: { enabled: false, phone_number: '', carrier: '' },
    dashboard_alerts: {
      enabled: true,
      sound_enabled: true,
      popup_enabled: true,
      alert_types: ['error', 'warning', 'info', 'success'],
    },
    trigger_events: {
      indicator_activated: true,
      execution_fired: true,
      execution_failed: true,
    },
  };
}
